// extracted by mini-css-extract-plugin
module.exports = {"PrivatePage":"PrivatePage_PrivatePage__98cLo","main":"PrivatePage_main__8HxPN","pageContent":"PrivatePage_pageContent__HqpKp"};